// Common API response enum
export enum STATUS_CODE {
    SUCCESS = 'success',
    FAIL = 'fail',
}
